import { render, staticRenderFns } from "./ChooseColor.vue?vue&type=template&id=ce224c2a&"
import script from "./ChooseColor.vue?vue&type=script&lang=js&"
export * from "./ChooseColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/22413/203/Snaply5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce224c2a')) {
      api.createRecord('ce224c2a', component.options)
    } else {
      api.reload('ce224c2a', component.options)
    }
    module.hot.accept("./ChooseColor.vue?vue&type=template&id=ce224c2a&", function () {
      api.rerender('ce224c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/snaply/ChooseColor.vue"
export default component.exports